import { motion, useReducedMotion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { EASE } from "@/components/motion/primitives";

/* Keyed enter-only fade. No AnimatePresence "wait" mode: an outgoing page whose
   DOM was mutated by a third-party script (RefTagger) can otherwise stall its
   exit animation and leave the next route blank until a hard refresh. Keying on
   pathname remounts + replays the enter animation on every navigation. */
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  const reduced = useReducedMotion();
  return (
    <motion.div
      key={pathname}
      initial={reduced ? false : { opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: reduced ? 0 : 0.34, ease: EASE }}
      className="relative flex-1"
      data-testid="page-transition"
    >
      {children}
    </motion.div>
  );
}
